module.exports = __webpack_public_path__ + "files/f8cb499557c2b4935cfa75a25920246d.png";